
import React, { Component } from 'react';
import AnimateHeight from 'react-animate-height';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import connect from '../store/connect';

class CustomSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
    this.setActive = this.setActive.bind(this);
  }

  componentDidUpdate(prevProps){
    if(prevProps.location !== this.props.location){
      this.setState({active: false});
    }
  }

  setActive() {
    this.setState({
      active: !this.state.active
    });
  }

  render() {
    const { children, title } = this.props;
    return (
      <CustomSelectWrapper>
        <MenuButton isActive={this.state.active} onClick={this.setActive}>{title}</MenuButton>
        <MenuWrapper>
          <AnimateHeight
            className="animation"
            duration={400}
            easing="ease-out"
            height={this.state.active ? 'auto' : 0}
          >
          {children}
          </AnimateHeight>
        </MenuWrapper> 
      </CustomSelectWrapper>
    );
  };
}

const CustomSelectWrapper = styled.div`
  position:relative;
  width: 100%; 
  background-color: #f2f2f2;
  margin-bottom: 10px;
`;

const MenuButton = styled.button`
  position: relative;
  min-height: 22px;
  font-size: 13px;
  background-color: transparent;
  border: none;
  padding: 12px 7px 12px 15px;
  outline: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  &:after {
    content: '';
    position:absolute;
    right: 12px;
    top: calc(50% - 6px);
    background-image: url(/images/icons/arrow.svg);
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 12px;
    height: 12px;    
    ${props => props.isActive && css`
      transform: rotateX(180deg);      
    `};
    -webkit-transition: -webkit-transform .25s ease-out;
    -webkit-transition: transform .25s ease-out;
    transition: transform .25s ease-out;
  }
  }
`;

const MenuWrapper = styled.div`
  position:absolute; 
  left: 0; 
  right: 0; 
  top: 100%;
  background-color: #f2f2f2;
`;

CustomSelect.defaultProps = {
  title: ''
};

CustomSelect.propTypes = {
  title: PropTypes.string,
  location: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default connect(CustomSelect);



// WEBPACK FOOTER //
// ./src/components/CustomSelect.js